import React, { Component } from "react";
import { Redirect, withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";

import styles from "./GenerateEnigmaWithAIStyles";
import GenerateEnigmaWithAIView from "./GenerateEnigmaWithAIView";
import ApiEnigma from "../../API/ApiEnigma";

class GenerateEnigmaWithAIComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      prompt: "",
      withAIImage: false,
      loading: false,
      error: "",
      success: "",
      isLogged: false,
    };
  }

  componentDidMount() {
    document.title = "Générer une énigme avec l'IA | Landing Zone";
  }

  handleChange = (field) => (event) => {
    const value =
      event.target.type === "checkbox"
        ? event.target.checked
        : event.target.value;
    this.setState({ [field]: value });
  };

  handleSubmit = async (event) => {
    event.preventDefault();
    this.setState({ loading: true, error: "", success: "" });

    try {
      const response = await ApiEnigma.generateEnigmaWithAI(
        this.state.prompt,
        this.state.withAIImage
      );

      if (response.status === 200) {
        this.setState({
          success: "L'énigme a été générée avec succès !",
          loading: false,
        });
      } else {
        this.setState({
          error:
            response.data ||
            "Une erreur est survenue lors de la génération de l'énigme.",
          loading: false,
        });
      }
    } catch (error) {
      this.setState({
        error: "Une erreur est survenue lors de la génération de l'énigme.",
        loading: false,
      });
    }
  };

  render() {
    const { classes } = this.props;

    if (this.state.isLogged) {
      return <Redirect to="/" />;
    }

    return (
      <GenerateEnigmaWithAIView
        {...this.props}
        state={this.state}
        classes={classes}
        handleSubmit={this.handleSubmit}
        handleChange={this.handleChange}
      />
    );
  }
}

export default withStyles(styles, { withTheme: true })(
  withRouter(GenerateEnigmaWithAIComponent)
);
